import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  vendorCode: {
    type: "text", name: "vendorCode", label: "Vendor Code", maxLength: 20
  },
  zoneID: {
    type: "select", name: "zoneID", label: "Zone ID", maxLength: 20
  },
  locationID: {
    type: "text", name: "locationID", label: "Location ID", maxLength: 20
  },
  skuCode: {
    type: "text", name: "skuCode", label: "SKU Code", maxLength: 50
  },
  cartonID: {
    type: "text", name: "cartonID", label: "Carton ID", maxLength: 20, xs: 3
  },
  palletNbr: {
    type: "text", name: "palletNbr", label: "Pallet Nbr", maxLength: 20, xs: 3
  },
  holdPallet:{
    type: "select", name: "holdPallet", label: "Hold Pallet", required: true, xs: 3
  }
};

const { vendorCode, zoneID, locationID, skuCode, cartonID, palletNbr, holdPallet } = formField;

export const formRender = [[zoneID, locationID, vendorCode, skuCode], [cartonID, palletNbr, holdPallet]];

export const initialValues = getInitialValues(formField);

export const adjustmentDetailValidation = Yup.object().shape({
  [vendorCode.name]: Yup.string().nullable().max(vendorCode.maxLength),
  [zoneID.name]: Yup.string().nullable().max(zoneID.maxLength),
  [locationID.name]: Yup.string().nullable().max(locationID.maxLength),
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength),
  [cartonID.name]: Yup.string().nullable().max(cartonID.maxLength),
  [palletNbr.name]: Yup.string().nullable().max(palletNbr.maxLength),
  [holdPallet.name]: Yup.object()
  .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
  .nullable().required(),
});
